import React, { ElementType, FC, ReactNode } from 'react';

//components
import AampeTooltip from '../../../../../components/shared/AampeTooltip/AampeTooltip';
import styled from 'styled-components';

//constants
import aampeTheme from '../../../../../constants/aampeTheme';

import { createShouldForwardProp } from 'helpers/shouldForwardProp';

const shouldForwardProps = createShouldForwardProp(['isDisabled']);
interface FormulaEditorToolbarIconProps {
    Icon: ElementType;
    onIconClick?: () => void;
    title: ReactNode | string;
    isDisabled?: boolean;
    showDot?: boolean;
}
const FormulaEditorToolbarIcon: FC<FormulaEditorToolbarIconProps> = ({
    Icon,
    onIconClick,
    title,
    isDisabled,
    showDot,
}) => {
    return (
        <AampeTooltip customZIndex={10} placement="top" title={title}>
            <IconWrapper isDisabled={isDisabled}>
                <Icon
                    onClick={() => {
                        if (!isDisabled) {
                            onIconClick?.();
                        }
                    }}
                />
                {showDot && <Dot />}
            </IconWrapper>
        </AampeTooltip>
    );
};

const IconWrapper = styled.div.withConfig({
    shouldForwardProp: shouldForwardProps,
})<{ isDisabled?: boolean }>(({ isDisabled }) => ({
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    color: isDisabled
        ? aampeTheme.colors.solidWG02
        : aampeTheme.colors.textAccessibleWG01,
    display: 'flex',
    alignItems: 'start',
}));

const Dot = styled.div({
    width: '4px',
    height: '4px',
    backgroundColor: aampeTheme.colors.orange06,
    borderRadius: '100%',
});

export default FormulaEditorToolbarIcon;
